import React from 'react';
import styled from 'styled-components';
import InputLabelHint from '../InputLabelHint';
import { colors } from '../../../../assets/styles/colors';
import { fontSize } from '../../../../assets/styles/typography';
import { breakpoints, breakpointsForMaxWidth } from '../../../../assets/styles/grid';

const Row = styled.div`
  padding: 0;
`;

const Label = styled.label.attrs({ htmlFor: props => props.inputId })`
  font-size: ${fontSize.textMd};
  color: ${colors.grayDark};
  line-height: 36px;
  margin-bottom: 0;
  @media only screen and (min-width: ${breakpoints.small}) {
    justify-content: flex-start;
    text-align: left;
  }
  @media only screen and (max-width: ${breakpointsForMaxWidth.small}) {
    margin-left: 4px;
    margin-top: 8px;
    margin-bottom: 2px;
  }
`;

const Required = styled.span`
  margin-left: 4px;
  color: ${colors.required};
`;

const HintWrapper = styled.span`
  margin-left: 4px;
`;

const Error = styled.div`
  font-size: ${fontSize.textSm};
  color: ${colors.error};
`;

const Warning = styled.div`
  font-size: ${fontSize.textSm};
  color: ${colors.gray};
`;

export const InputFirstGrowingWidthLabel = props => {
  const {
    name,
    label,
    hint,
    required,
    error,
    warning,
    children,
    hidden,
    invisible,
    inputId,
    bottomMargin,
  } = props;
  return (
    <div className="w-100" hidden={hidden} style={{ visibility: invisible ? 'hidden' : 'visible' }}>
      <Row className="w-100 row mx-0">
        <div className="d-flex pr-2">{children}</div>
        <div className="flex-grow-1">
          <Label name={name} inputId={inputId}>
            {label}
            {hint && (
              <HintWrapper>
                <InputLabelHint hint={hint} />
              </HintWrapper>
            )}
            {required && <Required>*</Required>}
          </Label>
          {error && <Error className="w-100 mt-1 pl-2">{error}</Error>}
          {warning && (
            <Warning className="w-100 mt-1 pl-2">
              <span>
                <i className="fas fa-exclamation-triangle fa-sm mr-1" />
                {warning}
              </span>
            </Warning>
          )}
        </div>
      </Row>
      {bottomMargin ? <div className="w-100 mb-2" /> : <></>}
    </div>
  );
};
